import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ErrorBoundaryDefault } from "@src/app/components/ErrorBoundary/ErrorBoundaryDefault.component";
import { useActiveMainTab } from "@src/app/tabs/context/hooks/useActiveMainTab";
import Main from "./components/Main/Main";

interface AppFrameProps {
  banners?: ReactNode;
  children: ReactNode;
  breadcrumbs?: ReactNode;
  title?: string;
  hideTitle?: boolean;
}

export default function AppFrame(props: AppFrameProps) {
  const { banners, breadcrumbs, children, title, hideTitle } = props;

  const { t } = useTranslation("translation");
  const configuredTitle = t("BROWSER_TITLE");
  const { activeMainTabName } = useActiveMainTab();

  useEffect(() => {
    document.title = [title, activeMainTabName, configuredTitle]
      .filter(Boolean)
      .join(" - ");
  }, [activeMainTabName, configuredTitle, title]);

  return (
    <Main
      banners={banners}
      breadcrumbs={breadcrumbs}
      title={hideTitle ? undefined : title}
    >
      <ErrorBoundaryDefault>{children}</ErrorBoundaryDefault>
    </Main>
  );
}
